import { Component, OnInit } from '@angular/core';
import { AuditLogService, IAuditLogEntry } from 'src/app/shared/services/audit-log.service';

interface IProfilePermission {
  perfil: string;
  acessarRelatorio: boolean;
  editarRelatorio: boolean;
  exportarExcel: boolean;
}

@Component({
  selector: 'app-audit-permissions',
  templateUrl: './audit-permissions.component.html',
  styleUrls: ['./audit-permissions.component.scss']
})
export class AuditPermissionsComponent implements OnInit {
  readonly permissoesPerfis: IProfilePermission[] = [
    { perfil: 'Master', acessarRelatorio: true, editarRelatorio: false, exportarExcel: false },
    { perfil: 'Admin', acessarRelatorio: true, editarRelatorio: true, exportarExcel: true },
    { perfil: 'Manager', acessarRelatorio: false, editarRelatorio: false, exportarExcel: false },
    { perfil: 'Doctor', acessarRelatorio: false, editarRelatorio: false, exportarExcel: false },
    { perfil: 'QuestionnaireAdmin', acessarRelatorio: false, editarRelatorio: false, exportarExcel: false }
  ];

  auditLog: IAuditLogEntry[] = [];

  constructor(private readonly auditLogService: AuditLogService) {}

  ngOnInit(): void {
    this.auditLog = this.auditLogService.getAuditLog().reverse();
  }

  limparHistorico(): void {
    this.auditLogService.clearAuditLog();
    this.auditLog = [];
  }
}
